import type { LifeOf } from '../types/data-types'
import usePerson from './usePerson'
import type { Gender } from '../types/persons'
import useData from './data-service'

const lifeOf = (name: string, text: string | undefined, sex: Gender): LifeOf => ({
  name,
  text,
  sex,
})

export default function useLifeOf(): LifeOf | undefined {
  const person = usePerson()
  const data = useData()

  if (!person || !data?.lifeSummary) return undefined
  return lifeOf(person?.name, data?.lifeSummary, person.gender)
}
